import styled from "styled-components";
import { phoneCountries } from "@/shared/utils/phoneCountries";

interface Props {
	code: string | null | undefined;
	/** Show the ISO code after the name (Country config); off for compact cells (Payments). */
	showCode?: boolean;
}

/** `[flag] [country name]` for the admin tables; falls back to the code when the country is unknown. */
export const CountryLabel = ({ code, showCode = false }: Props) => {
	if (!code) return <Muted>—</Muted>;
	const country = phoneCountries.find((c) => c.iso === code);
	return (
		<Row>
			{country?.flagUrl ? (
				<Flag src={country.flagUrl} alt="" />
			) : country?.flag ? (
				<Emoji aria-hidden="true">{country.flag}</Emoji>
			) : null}
			<Name>{country?.name ?? code}</Name>
			{showCode ? <Muted>{code}</Muted> : null}
		</Row>
	);
};

const Row = styled.span`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
	line-height: 20px;
`;
const Flag = styled.img`
	display: block;
	width: 20px;
	height: 20px;
	flex: 0 0 20px;
	border-radius: 50%;
	object-fit: cover;
`;
const Emoji = styled.span`
	width: 20px;
	font-size: 16px;
	line-height: 20px;
	text-align: center;
`;
const Name = styled.span`
	font-weight: 600;
	color: #303030;
	white-space: nowrap;
	line-height: 20px;
	/* Poppins sits high in its line box; nudge the glyphs onto the flag's centre line. */
	padding-top: 2px;
`;
const Muted = styled.span`
	color: #707070;
`;
